import { ReactNode } from 'react'
import { StyleBg } from './style'

interface ICategory {
  category?: string
  children?: ReactNode
}

const Category = ({ category, children }: ICategory) => {
  let bg = ''
  let tc = ''

  switch (category) {
    case 'Pending':
      bg = 'red200'
      tc = 'red800'
      break
    case 'UnSubscribed':
      bg = 'red200'
      tc = 'red800'
      break
    case 'Subscribed':
      bg = 'green200'
      tc = 'green500'
      break
    case 'Rejected':
    case 'Cancelled':
      bg = 'red800'
      tc = 'white'
      break
    case 'Paid':
      bg = 'green200'
      tc = 'green500'
      break
    case 'Unpaid':
      bg = 'redLight'
      tc = 'redNormal'
      break
    case 'Collected':
      bg = 'yellowLight'
      tc = 'yellow'
      break
    case 'Report Generated':
      bg = 'green200'
      tc = 'green500'
      break
    case 'Accepted':
      bg = 'green200'
      tc = 'green500'
      break
    case 'Approved':
      bg = 'green200'
      tc = 'green500'
      break
    default:
      bg = 'primary50'
      tc = 'primary'
  }

  return (
    <StyleBg bg={bg} tc={tc}>
      {category || children}
    </StyleBg>
  )
}

export default Category
